/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadStatus
 */
export interface PalAuthorizationLeadStatus {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadStatus
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadStatus
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthorizationLeadStatus
     */
    is_default?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadStatus
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadStatus
     */
    background_color?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadStatus interface.
 */
export function instanceOfPalAuthorizationLeadStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalAuthorizationLeadStatusFromJSON(json: any): PalAuthorizationLeadStatus {
    return PalAuthorizationLeadStatusFromJSONTyped(json, false);
}

export function PalAuthorizationLeadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'background_color': !exists(json, 'background_color') ? undefined : json['background_color'],
    };
}

export function PalAuthorizationLeadStatusToJSON(value?: PalAuthorizationLeadStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_default': value.is_default,
        'color': value.color,
        'background_color': value.background_color,
    };
}

